function getParticipantsIcon(participants) {
  if (!participants) {
    return null;
  }

  if (Array.isArray(participants)) {
    participants = participants[participants.length - 1];
  }
  const amount = Math.max.apply(null, participants.toString().match(/\d+/g));

  if (amount === 1) {
    return '1Parcitipante';
  } else if (amount === 2) {
    return '2Participantes';
  } else if (amount > 2) {
    return 'MasParticipantes';
  }
  return '1Parcitipante';
}

export default getParticipantsIcon;
